import BaseDefinitionForm from "./components/base-form";
import LoadingButton from "@mui/lab/LoadingButton";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { API_URL } from "../../utilities";
import { useAuth } from "../../context/auth";
import { useNotifications } from "@toolpad/core/useNotifications";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useEffect } from "react";
import { BaseDefinitionType } from "src/interface/enum/BaseDefinitionType ";
const validationSchema = Yup.object({
  definType: Yup.string().required("این فیلد الزامی است"),
  caption: Yup.string().required("این فیلد الزامی است"),
});

const initialValues = {
  caption: "",
  definType: "",
  other: "",
};

const NewBaseDefinition = ({
  open,
  handleClose,
  refetch,
}: {
  open: boolean;
  handleClose: () => void;
  refetch: () => void;
}) => {
  const { id } = useParams() || undefined;
  const location = useLocation();
  const { definInfo } = location.state || {}; // دریافت داده‌ها از state
  const { user } = useAuth();
  const { mutateAsync: insertAsync, isPending } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(API_URL + "base-definition", {
        method: "POST",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      console.log(error);
    },
  });
  const { mutateAsync: updateAsync, isPending: isEditLoading } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(API_URL + "base-definition/" + body.id, {
        method: "PUT",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log("eee", error);
    },
  });

  const notifications = useNotifications();
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues, // مقادیر اولیه فرم
    validationSchema, // schema اعتبارسنجی
    onSubmit: async (values) => {
      console.log("🚀 ~ onSubmit: ~ values:", values);
      if (
        values.other === "" &&
        //@ts-ignore
        values.definType === BaseDefinitionType.Tags
      ) {
        formik.setFieldError("other", "این فیلد الزامی است");
        return;
      }
      let res;
      if (id) {
        res = await updateAsync(values);
      } else {
        res = await insertAsync(values);
      }
      if (res.status) {
        notifications.show("آیتم جدید با موفقیت ثبت شد!", {
          key: "new-form",
          severity: "success",
          autoHideDuration: 5000,
        });

        refetch();
        handleClose();
      } else {
        notifications.show("خطا در ذخیره سازی!", {
          key: "err-form",
          severity: "error",
          autoHideDuration: 5000,
        });
      }
      formik.resetForm();
    },
  });

  useEffect(() => {
    if (id) {
      formik.setValues(definInfo);
    }
  }, [id]);
  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={"md"}
        PaperProps={{
          component: "form",
          onSubmit: formik.handleSubmit,
          sx: {
            width: "100%",
          },
        }}
      >
        <DialogTitle>
          {definInfo ? 'ویرایش آیتم "' + definInfo?.caption + '"' : "آیتم جدید"}
        </DialogTitle>
        <DialogContent>
          <BaseDefinitionForm formik={formik} />
        </DialogContent>
        <DialogActions>
          <LoadingButton
            loading={isPending || isEditLoading}
            variant="contained"
            color="success"
            size="medium"
            fullWidth
            type="submit"
          >
            ذخیره
          </LoadingButton>
          <Button color="error" variant="contained" onClick={handleClose}>
            انصراف
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default NewBaseDefinition;
